import { createFileRoute } from '@tanstack/react-router'

import { InjectableParamsDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-documentation/injectable-params-documentation-page.tsx'

export const Route = createFileRoute('/resources/documentation/injectable-params')({
  component: () => <InjectableParamsDocumentationPage audience="public" />,
})
